@if (component) {
<div class="categories-carousel p-b wrap-x wrap-l pos-relative show-arrows">
    <div class="center overflow-hidden">
        <h2 class="p-l-12 p-r-12 pos-relative w-12-s wrap-s p-t-5-s b-t-s b-col-42-s"
            [sizeClass]="'!S:title-decoration h1, S:h2'"
            *iCms="'title' of component"></h2>
        <p class="p1 wrap-s p-t-2-s"
           *iCms="'sub_title' of component; skipEmpty: true"></p>
    </div>
    <div class="p-t-20 p-t-10-m p-t-4-s p-b-6 p-b-7-m p-b-7-m p-r-4-s flex flex-middle"
         *ifSize="'!SM'">
        <div class="carousel-arrows flex flex-justify-between">
            <button class="carousel-button m-r-5 bg-col-w box-shadow b-radius-max"
                    type="button"
                    [attr.aria-label]="'Previous slide' | translate"
                    [ngClass]="'model-carousel-prev-' + uid">
                <i class="icon-chevron-left b-radius-max fill flex flex-justify-center flex-middle"
                   aria-hidden="true"></i>
            </button>
            <button class="carousel-button bg-col-w box-shadow b-radius-max"
                    type="button"
                    [attr.aria-label]="'Next slide' | translate"
                    [ngClass]="'model-carousel-next-' + uid">
                <i class="icon-chevron-right b-radius-max fill flex flex-justify-center flex-middle"
                   aria-hidden="true"></i>
            </button>
        </div>
    </div>
    <swiper class="m-t-5"
            [pagination]="{
                    el: '.categories-carousel-pagination-' + uid
                }"
            [slidesPerView]="'auto'"
            [centeredSlides]="true"
            [loop]="true"
            [navigation]="{
                    nextEl: '.model-carousel-next-' + uid,
                    prevEl: '.model-carousel-prev-' + uid
                }"
            [spaceBetween]="0"
            #carouselRef>
        @for (category of component.categories; track $index; let i = $index; let isLast = $last) {
        <ng-template swiperSlide>

            <div class="ratio-4-3 ratio-1-1-s overflow-hidden">
                <div class="fill _scale">
                    <a [routerLink]="category.link"
                       class="fill">
                        <shell></shell>
                        @if (category.image) {
                        <img class="fill z-1"
                             [image]="category.image">
                        }
                        @if (category.contentVariant === contentVariant.video) {
                        @if (category.contentVideoProvider === contentVideoProvider.vimeo) {
                        <vimeo-player class="fill z-2"
                                      [video-id]="category.contentVideoId"
                                      [background]="true"
                                      [loop]="true">
                        </vimeo-player>
                        }
                        @if (category.contentVideoProvider === contentVideoProvider.youtube) {
                        <youtube-player class="fill z-2"
                                        [video-id]="category.contentVideoId">
                        </youtube-player>
                        }
                        }
                    </a>

                    <shop-this-look [content]="category"></shop-this-look>

                </div>
            </div>
            @if (category.cta_copy) {
            <href [link]="category.link">
                <div [ngClass]="[category.position_cta === 'on_image' ? 'cta-link-on-image': 'bottom-6', category.cta_color || '']"
                     [sizeClass]="'!S:p1, S:p2'"
                     class="pos-absolute pos-relative-s inline-block-s left-50 cta-link underline z-2">
                    <span *iCms="'cta_copy' of category"></span>
                </div>
            </href>
            }

        </ng-template>
        }
    </swiper>
    <carousel-dots [carouselRef]="carouselRef"
                   [paginationClass]="'categories-carousel-pagination-' + uid"></carousel-dots>
</div>
}